<template>
  <figure v-lazyload class="image__wrapper">
    <ImageSpinner class="image__spinner" />
    <img class="image__item" :data-url="srcImage" alt="" />
  </figure>
</template>
<script>
import { getContentId, getType } from "@/utils/dbTool"
import ImageSpinner from "./ImageSpinner"
import LazyLoadDirective from "@/directives/LazyLoadDirective"
const THUMBNAIL_PREVIEW_SMALL = "small"

export default {
  name: "PreviewContentImage",
  props: ["content", "library"],
  components: { ImageSpinner },
  directives: {
    lazyload: LazyLoadDirective
  },
  data() {
    return {
      placeholders: {
        guide: require("@/../public/img/placeholders/guide.png"),
        guideTemplate: require("@/../public/img/placeholders/guide_template.png"),
        glbModel: require("@/../public/img/placeholders/threed.png"),
        pointCloud: require("@/../public/img/placeholders/threed.png"),
        interactiveText: require("@/../public/img/placeholders/interactive_text.png"),
        interactiveBook: require("@/../public/img/placeholders/interactive_text.png"),
        videovr: require("@/../public/img/placeholders/video_vr.png"),
      }
    }
  },
  computed: {
    srcImage() {
      const contentId = getContentId(this.content)
      const type = getType(this.content)

      if (this.placeholders[type]) return this.placeholders[type]

      const { major_revision, minor_revision } = this.content.header

      return `api/library/${this.library}/preview/${contentId}/${major_revision}/${minor_revision}/${THUMBNAIL_PREVIEW_SMALL}?view=${undefined}`
    }
  }
}
</script>

<style scoped>
.image__item {
  width: 100%;
}

.loaded .image__spinner {
  display: none;
}

.image__wrapper {
  text-align: center;
}
</style>
